export var CalcLanguage;
(function (CalcLanguage) {
    CalcLanguage["Javascript"] = "javascript";
})(CalcLanguage || (CalcLanguage = {}));
//# sourceMappingURL=calc.js.map